<template>
  <v-card :href="pizza.orderUrl" target="_blank">
    <v-img height="250" :src="pizza.imageUrl">
      <div class="numeric-info pa-4 pt-9">
        <span>
          <b class="numeric-info__price">{{ pizza.price }}₽ </b>
          <span class="numeric-info__price_kg">{{ Math.round(pizza.pricePerKg) }} ₽/кг</span>
        </span>
        <span class="numeric-info__weight">{{ pizza.weight.toFixed(1) }} кг</span>
      </div>
    </v-img>

    <v-card-title class="pb-1 pizza-name">
      {{ pizza.name }} 
    </v-card-title>

    <v-card-text>
      <img class="dealer-logo" :src="pizza.source.logoUrl">

      <div style="line-height: 14px" class="mt-2">
          <span v-for="(ingredient, i) in pizza.ingredients" :key="i" style="font-size: 12px;">
            {{ ingredient }}<span v-if="i != pizza.ingredients.length - 1">,</span>
          </span>
      </div>
    </v-card-text>
  </v-card>
</template>

<style>
  .v-card {
    border-radius: 15px !important;
    height: 380px !important;
  }

  .v-card__title.pizza-name {
    font-size: 18px !important; 
    line-height: 19px;
  }

  .dealer-logo {
    height: 25px; 
    position: absolute; 
    top: 7px; 
    left: 7px;
  }

  .numeric-info {
    width: 100%; 
    height: 70px; 
    position: absolute; 
    bottom: 0px;
    background-image: linear-gradient(to top, rgba(0,0,0, 0.8) , rgba(0,0,0, 0));
  }

  .numeric-info__price {
    font-size: 20px; 
    color: rgba(255,255,255,0.9);
  }

  .numeric-info__price_kg {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.6);
  }

  .numeric-info__weight {
    font-size: 17px; 
    float: right; 
    color: rgba(255,255,255,0.9);
  }
</style>

<script>
export default {
  name: 'PizzaCard',
  props: ['pizza']
};
</script>


